export class PayType {
    PayTypeCode;
    PayTypeDesc;
    Formula;
    SalaryPayType;
    constructor() {
        {
            this.PayTypeCode = "";
            this.PayTypeDesc = "";
            this.Formula = "";
            this.SalaryPayType = "";
        }
    }
}



// WEBPACK FOOTER //
// ./src/model/PayType.js